import { useIntl } from "react-intl";

import { SmartPickingIssueType } from "__graphql__/types";
import { IntlMessageId } from "shared/lang";
import {
  SmartPickingAlertCallout,
  SmartPickingAlertStatus,
} from "ui/SmartPickingAlertCallout/SmartPickingAlertCallout";

type AlertCopy = {
  status: SmartPickingAlertStatus;
  titleId: IntlMessageId;
  bodyId: IntlMessageId;
};

const alertCopyByIssueType: Record<SmartPickingIssueType, AlertCopy> = {
  [SmartPickingIssueType.missing]: {
    status: "missing",
    titleId: "components.picking.smart-picking-alert.missing.title",
    bodyId: "components.picking.smart-picking-alert.missing.body",
  },
  [SmartPickingIssueType.damaged]: {
    status: "damaged",
    titleId: "components.picking.smart-picking-alert.damaged.title",
    bodyId: "components.picking.smart-picking-alert.damaged.body",
  },
  [SmartPickingIssueType.expired]: {
    status: "expired",
    titleId: "components.picking.smart-picking-alert.expired.title",
    bodyId: "components.picking.smart-picking-alert.expired.body",
  },
  [SmartPickingIssueType.wrong]: {
    status: "wrong",
    titleId: "components.picking.smart-picking-alert.wrong.title",
    bodyId: "components.picking.smart-picking-alert.wrong.body",
  },
};

export type SmartPickingAlertProps = {
  issueType?: SmartPickingIssueType | null;
};

export function SmartPickingAlert({ issueType }: SmartPickingAlertProps) {
  const intl = useIntl();

  if (!issueType) {
    return null;
  }

  const copy = alertCopyByIssueType[issueType];

  if (!copy) {
    return null;
  }

  return (
    <SmartPickingAlertCallout
      status={copy.status}
      title={intl.formatMessage({ id: copy.titleId })}
      body={intl.formatMessage({ id: copy.bodyId })}
      marginBottom="s200"
    />
  );
}
